import React, { Component } from 'react';
import '../css/Commande.css';
import { connect } from "react-redux";
import back from '../img/back.svg';
import next from '../img/next.svg';
import close from '../img/close.png';
import charging from "../img/charging.gif";
import logo_oeil from '../img/eye_black.png';
import { prestaTele } from '../api/UserFunctions';
import Chargement from './Chargement';

const mapStateToProps = state => {
  return { commande_user:state.commande_user, profile_user: state.profile_user, presta_user: state.presta_user  };
};

class Commande extends Component {

  constructor(props){
    super(props);
    this.state = {
      deb: 0,
      nb_devis:15,
      search:false,
      find:'',
      setPresta:'',
      stylePresta1:{display:"none"},
      stylePresta2:{display:"none"},
      stylePresta3:{display:"none"},
      u:0,
      DateD:'',
      DateF:'',
      descr:'',
      ref:'',
      testVoir:false,
      styleVoir:{cursor:"hand"}
    }
    this.handlePageS = this.handlePageS.bind(this);
    this.handlePageP = this.handlePageP.bind(this);
    this.onChange = this.onChange.bind(this);
    this.renderTable = this.renderTable.bind(this);
    this.handleCroix1 = this.handleCroix1.bind(this);
    this.handleCroix2 = this.handleCroix2.bind(this);
    this.handleDetails = this.handleDetails.bind(this);
    this.handlePV = this.handlePV.bind(this);
    this.handleSuppr = this.handleSuppr.bind(this);
    this.renderTablePresta = this.renderTablePresta.bind(this);
    this.renderTablePresta2 = this.renderTablePresta2.bind(this);

  }

  handleCroix1(event){
    this.setState({stylePresta1:{display:"none"}});
    this.setState({stylePresta3:{display:"none"}});
  }

  handleCroix2(event){
    this.setState({stylePresta3:{display:"none"}});
  }


  onChange(e) {
    this.setState({ [e.target.name]: e.target.value })
    this.setState({search:true});
  }

  formatDate(date){
    let year = date.substring(0,4);
    let month = date.substring(4,6);
    let day = date.substring(6,8);

    return day+"/"+month+"/"+year;
  }



  renderTable(nb,nb2){
    if(this.state.search || typeof this.props.joinD !== 'undefined'){
      return this.renderTable2(nb,nb2);          
    }
    else if(typeof this.props.commande_user != "undefined"){
      return this.props.commande_user.map((commande,index) => {
        let testPresta="Aucune";
        let stylePresta = {color:'black'};
        let styleCursor = {cursor:"hand"};
        const{id, Client_Groupe, Libelle_Client, Code_Client, Num_Commande, Ref_Client, Date_Saisie_Commande, Num_Devis, Statut_Commande, HT, TTC} = commande;

        this.props.presta_user.forEach((presta,index) => {
          if(Num_Commande.localeCompare(presta["No_de_commande"])===0){
            testPresta="Oui";
            stylePresta = {color:"green"};
            styleCursor = {cursor:"pointer"};
          }
        });
        
        if(index<nb && index>=nb2){
          return (
            <tr key={id}>
              <td>{Client_Groupe}</td>
              <td style={{textAlign:"left"}}>{Libelle_Client}</td>
              <td>{Code_Client}</td>
              <td>{Num_Commande}</td>
              <td>{Ref_Client}</td>
              <td>{this.formatDate(Date_Saisie_Commande)}</td>
              <td>{Num_Devis}</td>
              <td>{Statut_Commande}</td>
              <td style={{textAlign:"right"}}>{new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' }).format(HT)}</td>
              <td style={{textAlign:"right"}}>{new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' }).format(TTC)}</td>
              <td id='presta' onClick={() => this.handlePresta(Num_Commande, testPresta)} style={Object.assign({}, {width:"9vw"},stylePresta, styleCursor)}>{testPresta}{testPresta.localeCompare("Oui")===0?<img id="eye_c" src={logo_oeil} alt="oeil"/>:null}</td>
            </tr>
          )
        }
        return null;    
      });
    }
    else{
      return null;
    }
  }

  renderTablePresta(){
      let u = 0;
      return this.props.presta_user.map((presta,index) => {
          //this.handleDetails(presta['No_ticket'])
          //this.handlePV(presta['No_ticket'])
            let html = presta['Description_ticket'];
            html = html.replace(/<style([\s\S]*?)<\/style>/gi, '');
            html = html.replace(/<script([\s\S]*?)<\/script>/gi, '');
            html = html.replace(/<\/div>/ig, '\n');
            html = html.replace(/<\/li>/ig, '\n');
            html = html.replace(/<li>/ig, '  *  ');
            html = html.replace(/<\/ul>/ig, '\n');
            html = html.replace(/<\/p>/ig, '\n');
            html = html.replace(/<br\s*[/]?>/gi, "\n");
            html = html.replace(/<[^>]+>/ig, ''); 
            u+=1;
            let val_voir = "";
            let val_style = {};
            let url = presta["Pdf_url"];
            if(presta["No_de_commande"].localeCompare(this.state.Num)==0){
            if("".localeCompare(presta["Pdf_url"]) == 0){
              val_voir="-";
              val_style={cursor:"hand"};
            }
            else{
              url = url.substring(102, url.length);
              if(url.substring(0,2).localeCompare("PV")===0){
                val_voir="Voir";
                val_style={cursor:"pointer"};
              }
              else{
                val_voir="-";
                val_style={cursor:"hand"};
              }
              
            }
            
                return (
                <tr key={u}>
                  <td className="td_presta">{presta["No_ticket"]}</td>
                  <td className="td_presta">{html}</td>
                  <td className="td_presta">{presta["Date_debut_planifie_action"].substring(0,11)}</td>
                  <td className="td_presta">{presta["Statut"]}</td>
                  <td className="td_presta" onClick={() => this.handlePV()} style={val_style}>{val_voir}</td>
                </tr>  
              ) 
            }
            else{
              return null;
            }
             
        });
        
  }

  renderTablePresta2(){
    if(typeof this.state.doc !== "undefined"){

      let u = 0;
      let t = true;
        u+=1;

        let nomDoc = this.state.doc;
        if ("".localeCompare(nomDoc) !== 0){
          var array = nomDoc.split(",");
          return array.map((url,index) => {
            let first = url
            url = url.substring(102, url.length);
            url = url.replace(/%/ig, ' ');
            url = url.replace(/2B/ig, ' ');
            url = url.replace(/25C3/ig, ' ');
            url = url.replace(/25A9/ig, ' ');
            if(url.substring(0,2).localeCompare("PV")===0){
              t=false;
              return (
                <p key={u} className="prestaNum3" onClick={() => this.handleTele(first)}>{url.substring(0,url.length-4)}</p>  
              )  
            }
            else{
              return null;
            }
          });
          }
          else{
            return null;

        }
      
    }
      

    
    return null; 
  }

  handleTele(link){
    prestaTele(link).then(res => {
          });
  }

  handleDetails(test){
    this.setState({stylePresta2:{display:"block"}});
    this.setState({stylePresta3:{display:"none"}});
      this.props.presta_user.forEach((presta,index) => {
          if(presta['No_ticket'].localeCompare(test)===0){
            this.setState({DateD:presta['Date_debut_planifie_action']});
            let html = presta['Description_ticket'];
            html = html.replace(/<style([\s\S]*?)<\/style>/gi, '');
            html = html.replace(/<script([\s\S]*?)<\/script>/gi, '');
            html = html.replace(/<\/div>/ig, '\n');
            html = html.replace(/<\/li>/ig, '\n');
            html = html.replace(/<li>/ig, '  *  ');
            html = html.replace(/<\/ul>/ig, '\n');
            html = html.replace(/<\/p>/ig, '\n');
            html = html.replace(/<br\s*[/]?>/gi, "\n");
            html = html.replace(/<[^>]+>/ig, '');
            this.setState({descr:html});
          }
        
        });

    
  }

  handlePV(){
    this.setState({stylePresta3:{display:"block"}});
    this.setState({stylePresta2:{display:"none"}});
    this.props.presta_user.forEach((presta,index) => {
      if(this.state.Num.localeCompare(presta["No_de_commande"])==0){
        this.setState({doc:presta['Pdf_url']});
      }
    });
  }

  handlePresta(presta1, testPresta){
    let listPresta = [];
    let u = 0;
    if(testPresta.localeCompare("Oui") === 0){
      this.setState({Num:presta1})
      this.setState({stylePresta1:{display:"block"}})
    }
    
    
  }


  renderTable2(nb,nb2){
    let mapping = [];
    let i = 0;
    if(typeof this.props.dataD !== 'undefined'){
      this.props.commande_user.forEach((commande,index) => {
        const{id, Client_Groupe, Libelle_Client, Code_Client, Num_Commande, Ref_Client, Date_Saisie_Commande, Num_Devis, Statut_Commande, HT, TTC} = commande;
        if((Num_Devis.toUpperCase().indexOf(this.props.dataD.toUpperCase()) !== -1) && id)
        {
          mapping[i] = commande;
          i++;
        }
      });
    }
    else{
      this.props.commande_user.forEach((commande,index) => {
        const{id, Client_Groupe, Libelle_Client, Code_Client, Num_Commande, Ref_Client, Date_Saisie_Commande, Num_Devis, Statut_Commande, HT, TTC} = commande;
        console.log("client "+Client_Groupe+" "+Libelle_Client+" "+Code_Client+" "+Num_Commande+" "+Ref_Client+" "+Date_Saisie_Commande+" "+Num_Devis+" "+Statut_Commande+" "+HT+" "+TTC)
        if((Client_Groupe.toUpperCase().indexOf(this.state.find.toUpperCase()) !== -1 || Libelle_Client.toUpperCase().indexOf(this.state.find.toUpperCase()) !== -1 || Code_Client.toUpperCase().indexOf(this.state.find.toUpperCase()) !== -1 || Num_Commande.toUpperCase().indexOf(this.state.find.toUpperCase()) !== -1  || Ref_Client.toUpperCase().indexOf(this.state.find.toUpperCase()) !== -1 || this.formatDate(Date_Saisie_Commande).toUpperCase().indexOf(this.state.find.toUpperCase()) !== -1 || Num_Devis.toUpperCase().indexOf(this.state.find.toUpperCase()) !== -1 || Statut_Commande.toUpperCase().indexOf(this.state.find.toUpperCase()) !== -1 || HT.toString().toUpperCase().indexOf(this.state.find.toUpperCase()) !== -1 || TTC.toString().toUpperCase().indexOf(this.state.find.toUpperCase()) !== -1) && id)
        {
          mapping[i] = commande;
          i++;
        }
      });
    }
    while((nb-mapping.length)>15){
      nb-=15;
      nb2-=15;
    }
    return mapping.map((commande,index) => {
      const{id, Client_Groupe, Libelle_Client, Code_Client, Num_Commande, Ref_Client, Date_Saisie_Commande, Num_Devis, Statut_Commande, HT, TTC} = commande;
      if( (Client_Groupe.toUpperCase().indexOf(this.state.find.toUpperCase()) !== -1 || Libelle_Client.toUpperCase().indexOf(this.state.find.toUpperCase()) !== -1 || Code_Client.toUpperCase().indexOf(this.state.find.toUpperCase()) !== -1 || Num_Commande.toUpperCase().indexOf(this.state.find.toUpperCase()) !== -1 || Ref_Client.toUpperCase().indexOf(this.state.find.toUpperCase()) !== -1 || this.formatDate(Date_Saisie_Commande).toUpperCase().indexOf(this.state.find.toUpperCase()) !== -1 || Num_Devis.toUpperCase().indexOf(this.state.find.toUpperCase()) !== -1 || Statut_Commande.toUpperCase().indexOf(this.state.find.toUpperCase()) !== -1 || HT.toString().toUpperCase().indexOf(this.state.find.toUpperCase()) !== -1 || TTC.toString().toUpperCase().indexOf(this.state.find.toUpperCase()) !== -1) && id)
      {
        let testPresta="Aucune";
        let stylePresta = {color:"black"};
        let styleCursor = {cursor:"hand"};
        const{id, Client_Groupe, Libelle_Client, Code_Client, Num_Commande, Ref_Client, Date_Saisie_Commande, Num_Devis, Statut_Commande, HT, TTC} = commande;

        this.props.presta_user.forEach((presta,index) => {
          if(Num_Commande.localeCompare(presta["No_de_commande"])===0 && ("Projet".localeCompare(presta["Groupe_affectation"])===0 || "Infrastructure".localeCompare(presta["Groupe_affectation"]))){
            testPresta="Oui";
            stylePresta = {color:"green"};
            styleCursor = {cursor:"pointer"};
          }
        });
          
          if(index<nb && index>=nb2){     
            return (
              <tr key={id}>
                <td>{Client_Groupe}</td>
                <td style={{textAlign:"left"}}>{Libelle_Client}</td>
                <td>{Code_Client}</td>
                <td>{Num_Commande}</td>
                <td>{Ref_Client}</td>
                <td>{this.formatDate(Date_Saisie_Commande)}</td>
                <td>{Num_Devis}</td>
                <td>{Statut_Commande}</td>
                <td style={{textAlign:"right"}}>{new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' }).format(HT)}</td>
                <td style={{textAlign:"right"}}>{new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' }).format(TTC)}</td>
                <td id='presta' onClick={() => this.handlePresta(Num_Commande, testPresta)} style={Object.assign({}, stylePresta, styleCursor, {width:"9vw"})}>{testPresta}{testPresta.localeCompare("Oui")===0?<img id="eye_c" src={logo_oeil} alt="oeil"/>:null}</td>
              </tr>
            )
          }
        return null;
      }
      return null;
    });
  }

  handlePageS(){
    if(this.state.nb_devis < this.props.commande_user.length){
      let nb_deb = this.state.deb;
      let nb_fin = this.state.nb_devis;
      this.setState({deb:nb_deb+15});
      this.setState({nb_devis:nb_fin+15});
    }
    
  }

  handlePageP(){

    if(this.state.deb >= 15){
      let nb_deb = this.state.deb;
      let nb_fin = this.state.nb_devis;
      this.setState({deb:nb_deb-15});
      this.setState({nb_devis:nb_fin-15});
    }
   
  }

  handleSuppr(event){

    this.setState({find:''});
   
  }


  render() {
    
      return (

    <div className="commande">
      <input
        id="search"
        type="text"
        placeholder="Recherche"
        name="find"
        value={this.state.find}
        onChange={this.onChange}
        onClick={(event) => this.handleSuppr(event)}
      /> {this.state.find.localeCompare("")==0?null:<img id="croix_cmd3" onClick={(event) => this.handleSuppr(event)} src={close} alt="croix"/>}

      <table >
        <thead id="table_d">
          <tr>
            <th>GROUPE</th>
            <th>LIBELL&Eacute; CLIENT</th> 
            <th>CODE<br/>CLIENT</th>
            <th>N°<br/>COMMANDE</th>
            <th>REF CDE<br/>CLIENT</th>
            <th>SAISIE<br/>DE COMMANDE</th>
            <th>N°<br/>DE DEVIS</th>
            <th>STATUT DE LA<br/>COMMANDE</th>
            <th>MONTANT<br/>HT</th>
            <th>MONTANT<br/>TTC</th>
            <th>PRESTATIONS<br/>PLANIFI&Eacute;ES</th>
          </tr>
        </thead>
        <tbody>
          {this.renderTable(this.state.nb_devis,this.state.deb)}
        </tbody>
      </table>
      <div id="page_c">
        <img id="pagePC" onClick={(event) => this.handlePageP(event)} src={back} alt="Logo back"/>
        <img id="pageSC" onClick={(event) => this.handlePageS(event)} src={next} alt="Logo next"/>
      </div>

      <div id="modalPresta1" style={this.state.stylePresta1} >
            <div className="modal-content1" >
              <p id="forget_title1">Actions prévues<img id="croix_cmd" onClick={(event) => this.handleCroix1(event)} src={close} alt="croix"/></p>
              <div id="detail_content">
                <table >
                  <thead>
                    <tr>
                      <th className="th_cmd">N° de ticket</th>
                      <th className="th_cmd">Déscriptif</th> 
                      <th className="th_cmd">Date d'intervention</th>
                      <th className="th_cmd">Statut</th>
                      <th className="th_cmd">Pièce jointe</th>
                    </tr>
                  </thead>
                  <tbody id="table_presta">
                    {this.renderTablePresta()}
                  </tbody>
                </table>
              </div>
              
            </div>      
      </div>
      <div id="modalPresta3" style={this.state.stylePresta3} >
              <p id="forget_title3">Procès-verbaux<img id="croix_cmd2" onClick={(event) => this.handleCroix2(event)} src={close} alt="croix"/></p>
              {this.renderTablePresta2()}   
      </div>
    </div>
    );
    
    }

  }
export default connect(mapStateToProps)(Commande);
